import { useEffect } from "react";

import { Input } from "neetoui";
import { useTranslation } from "react-i18next";

import DynamicQueryParams from "./DynamicQueryParams";

import useProductEmbedStore from "../useProductEmbedStore";

const ElementPopup = ({
  customization,
  updateCustomization,
  otherCustomizations,
}) => {
  const { elementSelector } = customization;
  const { t } = useTranslation();
  const { isQueryParamsEnabled } = useProductEmbedStore.pick();

  useEffect(() => {
    if (isQueryParamsEnabled) return;

    updateCustomization({ queryParams: undefined });
  }, []);

  return (
    <>
      <Input
        className="w-full"
        data-testid="element-id-input-field"
        helpText={t("neetoMolecules.productEmbed.elementPopup.callout")}
        label={t("neetoMolecules.productEmbed.elementPopup.elementId")}
        value={elementSelector}
        error={
          !elementSelector &&
          t("neetoMolecules.productEmbed.elementPopup.elementIdError")
        }
        onChange={e => updateCustomization({ elementSelector: e.target.value })}
      />
      {otherCustomizations()}
      {isQueryParamsEnabled && (
        <DynamicQueryParams {...{ updateCustomization }} />
      )}
    </>
  );
};

export default ElementPopup;
